import React from "react";
import { Helmet } from "react-helmet-async";

const HelmetSeo = ({ title, name, content, relCa, hrefCa, relAl, hrefAl }) => {
  
  return (
    <Helmet>
      <title>{title}</title>
      <meta name={name} content={content} />
      <link rel={relCa} href={hrefCa} />
      <link rel={relAl} href={hrefAl} />
    </Helmet>
  );
};

export default HelmetSeo;
